import React from "react"

import {contacts as contactsDefault, contactsKz, contactsBy} from "../common/contacts"
import {Locales} from "../../../localization/types";

const PHONE_NUMBER_BY_LOCALE = {
	DEFAULT: ''
}

export const getData = (locale: Locales) => {
	let contacts = contactsDefault
	if (locale === 'ru-KZ') {
		contacts = contactsKz
	}
	if (locale === 'ru-BY') {
		contacts = contactsBy
	}

	return {
		blockName: "Часто задаваемые вопросы",
		title: "Что рассказать еще?",
		questions: [
			{
				question: "Где можно подробнее узнать о возможностях каждого тарифа?",
				answer: (
					<div>
						Подробную информацию о&nbsp;каждом тарифе вы можете изучить в{" "}
						<a href="/price/compare/" target="_blank">
							таблице
						</a>
						.
						<br />
						Если останутся вопросы, звоните по номеру{" "}
						<a href={`tel:${contacts.phone.value}`}>{contacts.phone.text}</a> или
						пишите на почту{" "}
						<a href={`mailto:${contacts.salesEmail}`}>{contacts.salesEmail}</a>
						.
						<br />
						<a
							href={contacts.orderPricesUrl}
							target="_blank"
							rel="noreferrer"
						>
							Приказ о тарифах Quick Resto
						</a>
						.
					</div>
				),
			},
			{
				question:
					"Какие дополнительные затраты могут быть при внедрении Quick Resto?",
				answer: (
					<div>
						Кроме оплаты подписки, других затрат Quick Resto не&nbsp;требует. Мы
						не берём доплат за количество пользователей, обновления и&nbsp;решение
						технических проблем. При этом вы можете индивидуально заказать
						дополнительные услуги по&nbsp;настройке системы и&nbsp;обучению
						персонала.
					</div>
				),
			},
			{
				question:
					"Возможна ли автоматизация «под ключ», обучение сотрудников и прочее?",
				answer: (
					<div>
						Да, для вашего комфорта мы&nbsp;проводим автоматизацию «под&nbsp;ключ»
						и&nbsp;оказываем дополнительные услуги по&nbsp;обучению персонала.
						Вы&nbsp;можете ознакомиться с{" "}
						<a
							href="https://disk.yandex.ru/i/MhHO6yT-ozTwtA"
							target="_blank"
							rel="nofollow"
						>
							прайсом
						</a>
						.
					</div>
				),
			},
			{
				question: "Какой договор заключается с Quick Resto?",
				answer: (
					<div>
						Отношения между Quick Resto и вашей компанией регулируются{" "}
						<a href="/licenseAgreement/" target="_blank">
							лицензионным договором
						</a>
						.
					</div>
				),
			},
		],
	}
}
